


<script>
import p0 from "./p0"
import p1 from "./p1"
import p2 from "./p2"
import p3 from "./p3"
import p4 from "./p4"
export default {
  name: 'HelloWorld',
  
  components: {
    p0,
    p1,
    p2,
    p3,
    p4
  }
}
</script>

<template>
  <div class="surround">
    <p0 />
    <p1 />
    <p2 />
    <p3 />
    <p4 />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue